import type { Request, RequestArguments } from "./request";


export interface Context<T extends RequestArguments = RequestArguments>
{
    request: Request<T>;
    parent?: Context;
}
